import Firebase from 'firebase';
import axios from 'axios';
//TODO : Check alternative
//import {CricrushConfig} from './../../cc-imports'


const FirebaseNotificationUtils = {

    addOnMessageListener(listener) {
        Firebase.messaging().onMessage(listener);
    },

    requestNotificationPermission () {
        Firebase.messaging().requestPermissions();

    },

    composeTopic(matchKey,notificationType){
        /*if (matchKey && notificationType) {
            var topic = '/topics/follow-' + matchKey + '-'+CricrushConfig.firebaseConfig.env+'-' + notificationType;
            //console.log(topic)
            return topic;
        }*/
    },

    subscribeTopicNotification(matchKey, notificationType) {
        try {
            this.requestNotificationPermission();
            Firebase.messaging().subscribeToTopic(FirebaseNotificationUtils.composeTopic(matchKey,notificationType));
        } catch (error) {
           // console.log(error, 'TOPIC_SUBCRIBE_ERROR');
        }
    },

    subscribeToAllUsersNotifications() {
        try {
            this.requestNotificationPermission();
            //Firebase.messaging().subscribeToTopic('/topics/follow-'+CricrushConfig.firebaseConfig.env+'-ALL_USERS');
        } catch (error) {
            //console.log(error, 'TOPIC_SUBCRIBE_ERROR');
        }
    },

    getDeviceToken(callback) {
        Firebase.messaging().getToken().then(callback);
        //console.log('getDeviceToken Callback function running');
    },

    createDeviceGroup(notificationKeyName, deviceToken, callback, errorCallback) {
        const url = 'https://android.googleapis.com/gcm/notification';
        const config = {
            /*headers: {
                "Content-Type": "application/json",
                "Authorization": "key="+CricrushConfig.cloudMessaging.authKey,
                "project_id": CricrushConfig.cloudMessaging.senderId
            }*/
        };
        var data = {
            operation: "create",
            notification_key_name: notificationKeyName,
            registration_ids: [deviceToken]
        };

        axios.post(url, data, config)
            .then((response) => {
                callback && callback(response);
            })
            .catch((error) => {
                errorCallback && errorCallback(error);
            });
    },

    getDeviceGroup(notificationKeyName, callback, errorCallback){
        let getUrl = 'https://android.googleapis.com/gcm/notification?notification_key_name='+notificationKeyName;
        const getConfig = {
            method: 'GET',
            /*headers: {
                "Content-Type": "application/json",
                "Authorization": "key="+CricrushConfig.cloudMessaging.authKey,
                "project_id": CricrushConfig.cloudMessaging.senderId
            }*/
        };

        const myRequest = new Request(getUrl, getConfig);

        fetch(myRequest).then( (response) => {
            response.json().then((body) => {
                if(body.error){
                    errorCallback && errorCallback(body);
                }
                else {
                    callback && callback(body);
                }

            });

        }).catch((err)=>{
            errorCallback && errorCallback();
        });
    },

    addToDeviceGroup(notificationKeyName, notificationKey, deviceToken, callback, errorCallback) {
        const url = 'https://android.googleapis.com/gcm/notification';
        const config = {
           /* headers: {
                "Content-Type": "application/json",
                "Authorization": "key="+CricrushConfig.cloudMessaging.authKey,
                "project_id": CricrushConfig.cloudMessaging.senderId
            }*/
        };
        var data = {
            operation: "add",
            notification_key_name: notificationKeyName,
            notification_key: notificationKey,
            registration_ids: [deviceToken]
        };

        axios.post(url, data, config)
            .then((response) => {
               callback && callback(response);
            })
            .catch((error) => {
               errorCallback && errorCallback(error);
            });
    },

    removeFromDeviceGroup(notificationKeyName, notificationKey, deviceToken, callback, errorCallback) {
        const url = 'https://android.googleapis.com/gcm/notification';
        const config = {
            /*headers: {
                "Content-Type": "application/json",
                "Authorization": "key="+CricrushConfig.cloudMessaging.authKey,
                "project_id": CricrushConfig.cloudMessaging.senderId
            }*/
        };
        var data = {
            operation: "remove",
            notification_key_name: notificationKeyName,
            notification_key: notificationKey,
            registration_ids: [deviceToken]
        };

        axios.post(url, data, config)
            .then((response) => {
                callback && callback(response);
            })
            .catch((error) => {
                errorCallback && errorCallback(error);
            });
    },

    subscribeToDeviceGroup(notificationKeyName) {
        this.getDeviceToken((deviceToken) => {
            FirebaseNotificationUtils.getDeviceGroup(notificationKeyName,(response)=>{
                FirebaseNotificationUtils.addToDeviceGroup(notificationKeyName,response.notification_key, deviceToken, ()=>{},()=>{});
            },(err)=>{
                FirebaseNotificationUtils.createDeviceGroup(notificationKeyName,deviceToken,(response)=>{
                    //console.log(response);
                },(err)=>{
                   // console.log(err);
                });
            })
        });
    },

    unsubscribeFromDeviceGroup(notificationKeyName){
        this.getDeviceToken(function(deviceToken) {
            FirebaseNotificationUtils.getDeviceGroup(notificationKeyName,(response)=>{
                FirebaseNotificationUtils.removeFromDeviceGroup(notificationKeyName,response.notification_key, deviceToken, ()=>{},()=>{});
            },(err)=>{

            })
        });
    },

    removeAllNotificationTokens() {
        Firebase.messaging().deleteInstanceId();
    },

    unsubscribeFromTopic (matchKey, notificationType) {
        Firebase.messaging().unsubscribeFromTopic(FirebaseNotificationUtils.composeTopic(matchKey,notificationType));
    }

};

export default FirebaseNotificationUtils;


// WEBPACK FOOTER //
// ./src/app/lib/firebase/FirebaseNotificationUtils.js